<template>
  <div class="main_content">
    <a-spin :spinning="spinLoading">
      <div style="overflow-x: hidden;overflow-y: auto;height: 70vh;">
        <a-form-model ref="form"
                      :model="form"
                      :rules="rules"
                      :label-col="{ flex: '0 0 auto' }"
                      :wrapper-col="{ span: 24 }"
                      class="exi_form item_100 large">
          <div class="title">基本信息</div>
          <a-divider/>
          <a-row :gutter="20">
            <a-col :span="16">
              <a-row :gutter="20"
                     type="flex">
                <a-col :span="12">
                  <a-form-model-item label="证件类型"
                                     prop="certificateType">
                    <dict-radio v-model="form.certificateType" :disabled="isExpert"
                                dictKey="certificate_type"
                                placeholder="证件类型"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item prop="idCard" label="证件号码">
                    <a-input v-model="form.idCard" :disabled="isExpert"
                             placeholder="证件号码"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="姓名"
                                     prop="expertName">
                    <a-input v-model="form.expertName"
                             placeholder="姓名"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="性别"
                                     prop="gender">
                    <dict-radio v-model="form.gender"
                                dictKey="PEOPLE.SEX"
                                placeholder="性别"
                                @change="(val) => { form.gender = val }"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item prop="mobilePhone" label="手机号码">
                    <a-input v-model="form.mobilePhone" :disabled="isExpert"
                             placeholder="手机号码"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="所在行政区域"
                                     prop="areaAddress">
                    <dict-cascader v-model="form.areaAddress"
                                   dictKey="COUNTRY.CITY" :changeOnSelect="false"
                                   placeholder="所在行政区域"
                                   style="width: 100%"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24">
                  <a-form-model-item label="联系地址"
                                     prop="address">
                    <a-input v-model="form.address"
                             placeholder="联系地址"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="紧急联系电话"
                                     prop="emergencyMobilePhone">
                    <a-input v-model="form.emergencyMobilePhone"
                             placeholder="紧急联系电话"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="电子邮箱"
                                     prop="email">
                    <a-input v-model="form.email"
                             placeholder="电子邮箱"/>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col :span="8">
              <a-form-model-item prop="peoplePicture" label="照片">
              </a-form-model-item>
              <div style="margin-bottom: 12px"></div>
              <avatar-upload-selector @objChange="fileChange($event,'peoplePictureList','peoplePicture')"
                                      config-key="expert.apply.peoplePicture" :refer-id="form.id"/>
              <div class="descrition-text">请上传1寸或2寸本人免冠正面头像照片（证件照为佳）</div>
              <div class="descrition-text">请上传不超过2M大小的照片，并且仅支持PNG、JPG、JPEG格式</div>
            </a-col>
          </a-row>
          <div class="title">银行信息</div>
          <a-divider/>
          <a-row :gutter="20">
            <a-col :span="8">
              <a-form-model-item label="开户银行"
                                 prop="openingBank">
                <a-input v-model="form.openingBank"
                         placeholder="请输入开户银行"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="银行账号"
                                 prop="bankAccount">
                <a-input v-model="form.bankAccount"
                         placeholder="请输入银行账号"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <div class="title">工作信息</div>
          <a-divider/>
          <a-row :gutter="20">
            <a-col :span="8">
              <a-form-model-item label="是否在职"
                                 prop="isIncumbency">
                <dict-radio v-model="form.isIncumbency"
                            dictKey="is_incumbency"
                            placeholder="是否在职"
                            @change="(val) => { if(val==='1'){ form.retireDate= undefined }else { form.unitProperties =undefined;form.position=undefined}}"/>
              </a-form-model-item>
            </a-col>

            <a-col :span="16">
              <a-form-model-item :label="!isExistIncumbency?'退休工作单位全称':'当前工作单位全称'"
                                 prop="unitName">
                <a-input v-model="form.unitName"
                         :rules="[{ required: true, message:'请输入工作单位全称', trigger: 'blur' },
                               {max: 50,message: '单位全称有误！最多50个字',trigger: 'blur'}]"
                         placeholder="请输入单位全称"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <a-col :span="8" v-if="!isExistIncumbency">
              <a-form-model-item label="退休日期"
                                 prop="retireDate"
                                 :rules="[{ required: true, message: '请选择退休日期', trigger: 'change' }]">
                <a-month-picker v-model="form.retireDate" :disabled-date="disabledDate"
                                format="YYYY年MM月"
                                placeholder="退休日期"
                                style="width: 100%"/>
              </a-form-model-item>
            </a-col>
            <template v-if="isExistIncumbency">
              <a-col :span="8">
                <a-form-model-item label="当前工作单位性质"
                                   prop="unitProperties">
                  <dict-cascader v-model="form.unitProperties"
                                 dictKey="expert_unitProperties"
                                 placeholder="当前工作单位性质"
                                 style="width: 100%"/>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="职务"
                                   prop="position">
                  <a-input v-model="form.position"
                           placeholder="职务"/>
                </a-form-model-item>
              </a-col>
            </template>
          </a-row>
          <a-row :gutter="20">
            <a-col>
              <a-form-model-item label="其他需回避的单位"
                                 prop="avoidUnit">
                <a-textarea v-model="form.avoidUnit"
                            auto-size
                            placeholder="请输入单位的标准全称，并且每个单位单独占一行。如没有回避单位则留空不填。"></a-textarea>
              </a-form-model-item>
              <div class="descrition-instructions">
                <div>其他需回避单位包括：</div>
                <div>（1）三年内担任过董事、监事、控股股东或实际控制人的单位；</div>
                <div>（2）夫妻、直系血亲、三代以内旁系血亲或者近姻亲关系的担任法定代表人或者负责人的单位；</div>
                <div>（3）因其他原因可能影响采购活动公平、公正进行的关系单位。</div>
              </div>
            </a-col>
          </a-row>
          <div class="title">专业领域信息</div>
          <a-divider/>
          <a-row :gutter="20">
            <a-col>
              <a-form-model-item label="是否为国家库、省库专家"
                                 prop="otherSourceLibraryFlag">
                <a-radio-group v-model="form.otherSourceLibraryFlag" @change="changeOtherSourceLibraryFlag">
                  <a-radio :value="false">否</a-radio>
                  <a-radio :value="true">是</a-radio>
                </a-radio-group>
                <dict-checkbox class="ml-5"
                               v-if="form.otherSourceLibraryFlag"
                               v-model="form.otherSourceLibrary"
                               @change="onOtherSourceLibraryChange"
                               dictKey="other_expertbank"
                               placeholder="是否为国家库、省库、省综合库专家"/>
              </a-form-model-item>
            </a-col>
            <a-col>
              <a-form-model-item label="选择评审品目"
                                 prop="purchaseItem">
                <div class="d-flex">
                  <a-input :placeholder="`最多可选择${expert_item_max_num}个品目`"
                           readOnly
                           :disabled="isExpert"
                           v-model="form.purchaseItem"
                           @click="openPurchaseItems"></a-input>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <a-col :span="8">
              <a-form-model-item label="毕业院校"
                                 prop="school">
                <a-input v-model="form.school"
                         placeholder="毕业院校"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="最高学历"
                                 prop="education">
                <dict-cascader v-model="form.education"
                               :showSearch="false"
                               dictKey="expert_education"
                               placeholder="最高学历"
                               style="width: 100%"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="职称水平"
                                 prop="professionalTitle">
                <dict-cascader v-model="form.professionalTitle"
                               :showSearch="false"
                               dictKey="expert_professionalTitle"
                               placeholder="职称水平"
                               style="width: 100%"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="20" v-if="form.professionalTitle">
            <a-col>
              <a-form-model-item label="职称名称"
                                 prop="specificProfessionalTitle">
                <div class="d-flex">
                  <a-input v-model="form.specificProfessionalTitle"
                           placeholder="职称名称"
                           readOnly
                           @click="openProfessional"></a-input>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <a-col>
              <a-form-model-item label="专业领域"
                                 prop="skilledProfession">
                <a-textarea v-model="form.skilledProfession"
                            auto-size
                            placeholder="请对擅长的领域进行简要描述，可增加被抽中参加方案评审、需求调研、项目论证等非评标活动的几率。，字数在500字以内"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <a-col>
              <a-form-model-item label="学术成果"
                                 prop="majorResult">
                <a-textarea v-model="form.majorResult"
                            auto-size
                            placeholder="请输入学术成果，字数在500字以内"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <a-col>
              <a-form-model-item label="获得奖励"
                                 prop="reward">
                <a-textarea v-model="form.reward"
                            placeholder="请输入获得奖励，字数在500字以内"
                            auto-size/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <div class="title">证明材料</div>
          <a-divider/>
          <a-row :gutter="20">
            <a-col :span="12">
              <a-form-model-item class="horizontal"
                                 prop="iDCardScanned">
                <div class="inline-flex"
                     slot="label">
                  <span class="font-red" v-if="isExpert">*</span>身份证扫描件
                  <small>（文件格式为PDF、PNG、JPG、JPEG，单个大小不超过2M）</small>
                </div>
                <upload-selector @objChange="fileChange($event,'iDCardScannedFileList','iDCardScanned')" btnSize="large"
                                 :referId='form.id' configKey='expert.apply.idcard'/>

              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="diploma"
                                 :rules="{ required: isExpert, validator: checkDiploma, trigger: 'change' }"
                                 class="horizontal">
                <div class="inline-flex"
                     slot="label">
                  学历证书/毕业证书
                  <small>（文件格式为PDF、PNG、JPG、JPEG，单个大小不超过2M）</small>
                </div>
                <upload-selector @objChange="fileChange($event,'diplomaFileList','diploma')" btnSize="large"
                                 :referId='form.id' configKey='expert.apply.diploma'/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <a-col :span="12">
              <a-form-model-item prop="technicalTitleCertificates"
                                 :rules="{ required: isExpert, validator: checkTechnicalTitleCertificates, trigger: 'change'  }"
                                 class="horizontal">
                <div class="inline-flex"
                     slot="label">
                  专业技术职称证书
                  <small>（文件格式为PDF、PNG、JPG、JPEG，单个大小不超过2M）</small>
                </div>
                <upload-selector
                    @objChange="fileChange($event,'technicalTitleCertificatesFileList','technicalTitleCertificates')"
                    btnSize="large" :referId='form.id' configKey='expert.apply.technical'/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="form.otherSourceLibraryFlag">
              <a-form-model-item class="horizontal"
                                 prop="otherSourceLibraryCertificate"
                                 :rules="{required: form.otherSourceLibraryFlag && isExpert,validator: checkOtherSourceLibraryCertificate,trigger: 'change'}">
                <div class="inline-flex"
                     slot="label">
                  国家、省库专家证明材料
                  <small>（文件格式为PDF、PNG、JPG、JPEG，单个大小不超过2M）</small>
                </div>
                <upload-selector
                    @objChange="fileChange($event,'otherSourceLibraryFileList','otherSourceLibraryCertificate')"
                    btnSize="large" :referId='form.id' configKey='expert.apply.otherSourceLibrary'/>
              </a-form-model-item>
            </a-col>
            <a-col :span="form.otherSourceLibraryFlag?24:12">
              <a-form-model-item class="horizontal">
                <div class="inline-flex"
                     slot="label">
                  职业资格证书等其他资料
                  <small>（文件格式为PDF、PNG、JPG、JPEG，单个大小不超过2M）</small>
                </div>
                <upload-selector
                    @objChange="fileChange($event,'jobQualificationCertificateFileList','jobQualificationCertificate')"
                    btnSize="large" :referId='form.id' configKey='expert.apply.professional'/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>

      <div style="width: 200px;margin: auto">
        <a-button type="primary"
                  class="mt-5"
                  block
                  size="large"
                  :loading="saveLoading"
                  @click="submit">提交
        </a-button>
      </div>
    </a-spin>
    <choose-expert-purchase-item ref="items" is-show-search
                                 :visible="purchaseVisible"
                                 @success="purchaseSuccess"
                                 @cancel="purchaseVisible=false"/>
    <choose-expert-professional-title ref="professionalRef"
                                      :visible="professionalVisible"
                                      @success="professionalSuccess"
                                      @cancel="professionalVisible=false"/>
  </div>
</template>

<script>
import { PageView } from '@/layouts'
import DictRadio from '@/components/dict/DictRadio'
import DictCheckbox from '@/components/dict/DictCheckbox'
import DictCascader from '@/components/dict/DictCascader'
import { verify } from '@/epp/expertmain/common/js/verify.js'
import {
  CheckExpertIdCard,
  CheckExpertMobile,
  CheckUpdateExpertInfo,
  AddExpertInfo
} from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import { formWaring } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'
import UploadFile from '@/components/selector/UploadFile'
import ChooseExpertPurchaseItem from '@/epp/expertmain/purchaseitems/ChooseExpertPurchaseItem.vue'
import {
  CalculateAge,
  checkPurchaseItemNum,
  getItemLimitNum
} from '@/epp/expertmain/expertInfo/utils/ExpertFormUtil'
import UploadSelector from '@/components/selector/UploadSelector.vue'
import AvatarUploadSelector from '@/components/selector/AvatarUploadSelector.vue'
import { IsExpertOrg } from '@/utils/util'
import moment from 'moment/moment'
import ChooseExpertProfessionalTitle from '@/epp/expertmain/purchaseitems/ChooseExpertProfessionalTitle.vue'

const uuidv4 = require('uuid/v4')

export default {
  name: 'ExpertForm',
  props: {
    form: {
      type: Object,
      default: function () {
        return {
          id: uuidv4(),
          purchaseItem: undefined,
          purchaseItemCode: undefined,
          purchaseItemId: undefined,
          areaAddress: '44,4401',
          emergencyMobilePhone: '',
          isIncumbency: '1',
          otherSourceLibrary: undefined,
          otherSourceLibraryFlag: false,
          idCard: undefined,
          specificProfessionalTitle: undefined,
          otherSpecificProfessionalTitle: undefined,
          retireDate: null,
        }
      }
    },
    spinLoading: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
  },
  components: {
    ChooseExpertProfessionalTitle,
    AvatarUploadSelector,
    UploadSelector,
    ChooseExpertPurchaseItem,
    PageView,
    DictRadio,
    DictCascader,
    UploadFile,
    DictCheckbox
  },
  data () {
    let checkIDCardScanned = async (rule, value, callback) => {
      if (this.file.iDCardScannedFileList.length === 0 && this.isExpert) {
        return callback(new Error('请上传身份证扫描件'))
      }
      callback()
    }
    let checkDiploma = (rule, value, callback) => {
      if (this.file.diplomaFileList.length === 0 && this.isExpert) {
        return callback(new Error('请上传学历证书/毕业证书'))
      }
      callback()
    }
    let checkTechnicalTitleCertificates = (rule, value, callback) => {
      if (this.file.technicalTitleCertificatesFileList.length === 0 && this.isExpert) {
        return callback(new Error('请上传专业技术职称证书'))
      }
      callback()
    }
    const checkOtherSourceLibraryCertificate = (rule, value, callback) => {
      if (this.form.otherSourceLibraryFlag && this.file.otherSourceLibraryFileList.length === 0 && this.isExpert) {
        callback(new Error('请上传国家库、省库、省综合库入库证明截图'))
      }
      callback()
    }
    let checkPeoplePicture = (rule, value, callback) => {
      if (this.file.peoplePictureList.length === 0) {
        return callback(new Error('请上传个人照片'))
      }
      callback()
    }
    const checkIdCard = async (rule, value, callback) => {
      if (value.length > 18) {
        return callback(new Error('身份证号长度不能超过18位'))
      }
      if (this.form.certificateType === '1') {
        if (!new RegExp(verify.pattern_idcard15 + '|' + verify.pattern_idcard18).test(value)) {
          return callback(new Error('身份证号格式不正确'))
        }
      }
      let res = await CheckExpertIdCard(value, this.form.id)
      if (res.result) {
        return callback(new Error('该身份证号在入库申请中或已入库，请重新输入'))
      }
      callback()
    }
    //检查手机号
    const checkExpertMobilePhone = async (rule, value, callback) => {
      let res = await CheckExpertMobile(value, this.form.id)
      if (res.result) {
        return callback(new Error('该手机号在入库申请中或已入库，请重新输入'))
      }
    }
    //检查是否输入其他专家库
    const checkOtherSourceLibrary = (rule, value, callback) => {
      if (this.form.otherSourceLibraryFlag && !this.form.otherSourceLibrary) {
        return callback(new Error('请选择国家库、省库专家'))
      }
      callback()
    }
    //检查银行卡账号格式是否正确
    const checkBankAccount = (rule, value, callback) => {
      const reg = /^[0-9]{9,18}$/
      if (value && !reg.test(value)) {
        return callback(new Error('银行卡账号格式不正确'))
      }
      callback()
    }
    return {
      checkOtherSourceLibraryCertificate,
      checkDiploma,
      checkTechnicalTitleCertificates,
      // 专家品目最多选择个数
      expert_item_max_num: 1,
      retireYear: 0,
      verify,
      saveLoading: false,
      purchaseVisible: false,
      professionalVisible: false,
      file: {
        peoplePictureList: [],
        diplomaFileList: [],
        technicalTitleCertificatesFileList: [],
        jobQualificationCertificateFileList: [],
        iDCardScannedFileList: [],
        otherSourceLibraryFileList: [],
      },
      rules: {
        idCard: [{ required: true, message: '请输入证件号码', trigger: 'change' }, {
          validator: checkIdCard,
          trigger: 'change'
        }],
        certificateType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
        expertName: [{ required: true, message: '请输入专家名称', trigger: 'change' }],
        peoplePicture: [{ required: true, validator: checkPeoplePicture, trigger: 'change' }],
        purchaseItem: [{
          required: true,
          message: '请选择评审品目',
          trigger: 'change'
        }, { validator: checkPurchaseItemNum, trigger: 'change' }],
        mobilePhone: [{
          required: true,
          message: '请输入专家手机号',
          trigger: 'change'
        }, { validator: checkExpertMobilePhone, trigger: 'change' }],
        email: [{ pattern: verify.pattern_email, message: '电子邮箱有误！', trigger: 'change' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        isIncumbency: [{ required: true, message: '请选择是否在职', trigger: 'change' }],
        specificProfessionalTitle: [{ required: true, message: '请选择具体职称名称', trigger: 'change' }],
        position: [{ max: 50, message: '职务有误！最多50个字', trigger: 'change' }],
        school: [{ required: true, message: '毕业院校不能为空', trigger: 'change' },
          { max: 100, message: '毕业院校有误！最多100个字', trigger: 'change' }],
        education: [{ required: true, message: '请选择最高学历', trigger: 'change' }],
        professionalTitle: [{ required: true, message: '请选择职称水平', trigger: 'change' }],
        skilledProfession: [{ max: 500, message: '专业领域有误！最多500个字', trigger: 'change' }],
        majorResult: [{ max: 500, message: '学术成果有误！最多500个字', trigger: 'change' }],
        reward: [{ max: 500, message: '获得奖励有误！最多500个字', trigger: 'change' }],
        unitProperties: [{ required: true, message: '请选择当前工作单位性质', trigger: 'change' }],
        areaAddress: [{ required: true, message: '请选择行政区域', trigger: 'change' }],
        address: [{ required: true, message: '请输入联系地址', trigger: 'change' },
          { max: 150, message: '联系地址有误！最多150个字', trigger: 'change' }],
        iDCardScanned: [{ validator: checkIDCardScanned, trigger: 'change' }],

        // bankAccount: [{ validator: checkBankAccount, trigger: 'change' }],
        otherSourceLibraryFlag: [{ required: true, message: '请选择是否为国家库、省库专家', trigger: 'change' },
          { validator: checkOtherSourceLibrary, trigger: 'change' }],

        unitName: [{ required: true, message: '请输入工作单位', trigger: 'change' }, {
          max: 50, message: '单位全称有误！最多50个字', trigger: 'change'
        }]
      },
    }
  },
  async created () {
    this.expert_item_max_num = await getItemLimitNum()
  },
  watch: {
    'form.certificateType' (val, oval) {
      if (oval && val !== oval && this.form.idCard) {
        this.$refs.form?.validateField('idCard')
      }
    },
    'form.retireDate' (val) {
      this.retireYear = CalculateAge(val)
    },
    'form.professionalTitle' (val) {
      if (!val) {
        this.form.specificProfessionalTitle = undefined
        this.form.specificProfessionalTitleKey = undefined
        this.form.otherSpecificProfessionalTitle = undefined
      }
    }
  },
  computed: {
    isExistIncumbency () {
      return this.form.isIncumbency === '1'
    },
    //是否是专家角色
    isExpert () {
      return IsExpertOrg(this)
    }
  },
  methods: {
    disabledDate (current) {
      return current && current.format('YYYY-MM') > moment().format('YYYY-MM')
    },
    onOtherSourceLibraryChange () {
      this.$refs.form.validateField('otherSourceLibraryFlag')
    },
    changeOtherSourceLibraryFlag (val) {
      if (!val.target.value) {
        this.form.otherSourceLibrary = undefined
      }
    },
    //打开职称窗口
    openProfessional () {
      this.professionalVisible = true
      let result = []
      if (this.form.specificProfessionalTitleKey) {
        let keyArr = this.form.specificProfessionalTitleKey.split('；')
        let nameArr = this.form.specificProfessionalTitle.split('；')
        for (let i = 0; i < keyArr.length; i++) {
          const data = {}
          data['name'] = nameArr[i]
          data['value'] = keyArr[i]
          result.push(data)
        }
      }
      this.$refs.professionalRef.preView(result, this.form.otherSpecificProfessionalTitle)
    },
    //选择职称成功后
    professionalSuccess (data, otherSpecificProfessionalTitle) {
      // todo:读取配置控制多少个
      this.professionalVisible = false
      this.form.specificProfessionalTitle = data.map(item => item.selectedName).join('；')
      this.form.specificProfessionalTitleKey = data.map(item => item.selectedValue).join('；')
      if (otherSpecificProfessionalTitle) {
        this.form.specificProfessionalTitle = this.form.specificProfessionalTitle ? this.form.specificProfessionalTitle + '；' + otherSpecificProfessionalTitle : otherSpecificProfessionalTitle
      }
      this.form.otherSpecificProfessionalTitle = otherSpecificProfessionalTitle
      this.$refs.form.validateField('specificProfessionalTitle')
    },
    //采购品目选择成功后
    purchaseSuccess (data) {
      this.purchaseVisible = false
      this.form.purchaseItem = []
      this.form.purchaseItemId = data.map(item => item.fid).join('；')
      this.form.purchaseItem = data.map(item => item.fspmmc).join('；')
      this.form.purchaseItemCode = data.map(item => item.fspmbm).join('；')
      this.$refs.form.validateField('purchaseItem')
    },
    //打开采购品目
    openPurchaseItems () {
      this.purchaseVisible = true
      let result = []
      if (this.form.purchaseItemId) {
        let fidArr = this.form.purchaseItemId.split('；')
        let itemArr = this.form.purchaseItem.split('；')
        let codeArr = this.form.purchaseItemCode.split('；')
        for (let i = 0; i < fidArr.length; i++) {
          const data = {}
          data['fid'] = fidArr[i]
          data['fspmmc'] = itemArr[i]
          data['fspmbm'] = codeArr[i]
          result.push(data)
        }
      }
      this.$refs.items.preView(result)
    },
    //提交信息
    submit () {
      let that = this
      this.$refs.form.validate((valid, err) => {
        if (!valid) {
          formWaring(err)
          return
        }
        that.onHandleSubmit()
      })
    },
    async onHandleSubmit () {
      try {
        const data = { ...this.form }
        delete data.extras
        //移除最后一个匹配到的其他职称
        if (data.otherSpecificProfessionalTitle) {
          if (data.otherSpecificProfessionalTitle === data.specificProfessionalTitle){
            data.specificProfessionalTitle = undefined
          }else {
            const separator = '；'
            const otherTitle = data.otherSpecificProfessionalTitle
            const regex = new RegExp(`${separator}${otherTitle}$`)
            data.specificProfessionalTitle = data.specificProfessionalTitle.replace(regex, '')
          }
        }
        data.otherSourceLibrary = data.otherSourceLibrary && data.otherSourceLibrary.join(',')
        let msgType = this.isEdit ? '编辑' : '添加'
        data.avoidUnit = data.avoidUnit && data.avoidUnit.replace(/[\r\n]+/g, ',').replace(/\s+/g, '')
        data.retireDate = data.retireDate && data.retireDate.format('YYYY-MM-01')
        this.saveLoading = true
        let res = this.isEdit ? await CheckUpdateExpertInfo(data) : await AddExpertInfo(data)
        if (res.code !== 200) {
          this.$message.error(`${msgType}失败`)
          return
        }
        this.$message.success(`${msgType}成功`)
        this.$emit('success')
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.saveLoading = false
      }
    },
    fileChange (fileList, key, props) {
      this.file[key] = fileList
      this.$refs.form.validateField(props)
    },
  }
}
</script>

<style lang="less" scoped>
.main_content {
  /deep/ .ant-divider-horizontal {
    margin: 15px 0;
  }

  .font-red {
    display: inline-block;
    margin-right: 4px;
    color: #f5222d;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
  }


  /deep/ .ant-card {
    border: none;
    box-shadow: none;
    padding: 0;

    .exi_form {
      margin-bottom: 20px;

      .ant-form-explain {
        z-index: 1;
      }
    }
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    margin-top: 10px;
    border-left: 4px solid #1f76ff;
    line-height: 1;
    padding-left: 8px;
  }

  .descrition-instructions {
    color: #ff4f4f;
    padding: 10px;
    background-color: #fff3e9;
    margin-bottom: 15px;
    font-size: 16px;
  }
}

/deep/ .ant-upload-list-picture-card-container {
  width: 200px;
  height: 200px;

  .ant-upload-list-item {
    width: 200px;
    height: 200px;
  }
}

.color-red {
  color: red;
}
</style>

